import { render, staticRenderFns } from "./Appointment.vue?vue&type=template&id=2f3c0f3a"
import script from "./Appointment.vue?vue&type=script&lang=js"
export * from "./Appointment.vue?vue&type=script&lang=js"
import style0 from "./Appointment.vue?vue&type=style&index=0&id=2f3c0f3a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports